import BasketShopping from '@navbar/assets/basket-shopping-solid.svg?react';
import BoltLightning from '@navbar/assets/bolt-lightning-solid.svg?react';
import CalendarAltRegular from '@navbar/assets/calendar-alt-regular.svg?react';
import CalendarAltSolid from '@navbar/assets/calendar-alt-solid.svg?react';
import CalendarDay from '@navbar/assets/calendar-day-solid.svg?react';
import CalendarRegular from '@navbar/assets/calendar-regular.svg?react';
import CardsStack from '@navbar/assets/cards-stack.svg?react';
import CartShopping from '@navbar/assets/cart-shopping-solid.svg?react';
import Certificate from '@navbar/assets/certificate-solid.svg?react';
import ChalkboardTeacher from '@navbar/assets/chalkboard-teacher-solid.svg?react';
import ClickAndDesign from '@navbar/assets/click-and-design.svg?react';
import Code from '@navbar/assets/code-solid.svg?react';
import Columns from '@navbar/assets/columns.svg?react';
import Developers from '@navbar/assets/developers.svg?react';
import Download from '@navbar/assets/download-solid.svg?react';
import Dropbox from '@navbar/assets/dropbox.svg?react';
import Envelope from '@navbar/assets/envelope-solid.svg?react';
import EnvelopeStacked from '@navbar/assets/envelope-stack.svg?react';
import InboxCustomize from '@navbar/assets/inbox-customize.svg?react';
import ExtendedWarranty from '@navbar/assets/extended-warranty.svg?react';
import File from '@navbar/assets/file.svg?react';
import GaugeHigh from '@navbar/assets/gauge-high-solid.svg?react';
import Gears from '@navbar/assets/gears-solid.svg?react';
import GraduationCap from '@navbar/assets/graduation-cap-solid.svg?react';
import Headset from '@navbar/assets/headset.svg?react';
import LifeRing from '@navbar/assets/life-ring-solid.svg?react';
import Mailchimp from '@navbar/assets/mailchimp.svg?react';
import Newspaper from '@navbar/assets/newspaper.svg?react';
import PenClip from '@navbar/assets/pen-clip-solid.svg?react';
import PhotoFilm from '@navbar/assets/photo-film-solid.svg?react';
import PlayCircle from '@navbar/assets/play-circle-solid.svg?react';
import Play from '@navbar/assets/play-solid.svg?react';
import PlusSquare from '@navbar/assets/plus-square-solid.svg?react';
import Register from '@navbar/assets/register.svg?react';
import Scroll from '@navbar/assets/scroll-solid.svg?react';
import SearchLocation from '@navbar/assets/search-location-solid.svg?react';
import SignOut from '@navbar/assets/sign-out-alt-solid.svg?react';
import Sitemap from '@navbar/assets/sitemap.svg?react';
import Star from '@navbar/assets/star-solid.svg?react';
import UserCheck from '@navbar/assets/user-check-solid.svg?react';
import UserGear from '@navbar/assets/user-gear-solid.svg?react';
import UserPlus from '@navbar/assets/user-plus-solid.svg?react';

// Company icons
import CompanyCheck from '@company/assets/company-check-1.svg?react';
import LeaveCompany from '@company/assets/company-log-out-02.svg?react';
import PlusCompany from '@company/assets/company-plus.svg?react';
import ClockDisableCompany from '@company/assets/company-refresh-clock-disabled.svg?react';
import ClockCompany from '@company/assets/company-refresh-clock.svg?react';
import CompanyTeam from '@company/assets/company-team-1.svg?react';
import CompanyVector from '@company/assets/company-vector.svg?react';

const ICONS = {
    columns: Columns,
    user_check: UserCheck,
    search_location: SearchLocation,
    newspaper: Newspaper,
    chalkboard_teacher: ChalkboardTeacher,
    plus_square: PlusSquare,
    calendar_alt_regular: CalendarAltRegular,
    calendar_alt_solid: CalendarAltSolid,
    calendar_regular: CalendarRegular,
    calendar_day: CalendarDay,
    play: Play,
    play_circle: PlayCircle,
    graduation_cap: GraduationCap,
    mailchimp: Mailchimp,
    dropbox: Dropbox,
    scroll: Scroll,
    envelope: Envelope,
    envelope_stack: EnvelopeStacked,
    inbox_customize: InboxCustomize,
    life_ring: LifeRing,
    star: Star,
    basket: BasketShopping,
    bolt: BoltLightning,
    cart: CartShopping,
    certificate: Certificate,
    code: Code,
    developers: Developers,
    download: Download,
    gauge: GaugeHigh,
    gears: Gears,
    pen: PenClip,
    photo_film: PhotoFilm,
    sign_out: SignOut,
    user_gear: UserGear,
    user_plus: UserPlus,
    extended_warranty: ExtendedWarranty,
    register: Register,
    sitemap: Sitemap,
    event_new: 'nothing',
    company_check: CompanyCheck,
    company_vector: CompanyVector,
    company_team: CompanyTeam,
    company_leave: LeaveCompany,
    company_add_user: PlusCompany,
    company_clock: ClockCompany,
    company_clock_disable: ClockDisableCompany,
    click_and_design: ClickAndDesign,
    headset: Headset,
    file: File,
    cards_stack: CardsStack,
};

export { ICONS };
